/**
 * @group Project
 * @summary Project name
 * 
 * @remarks
 * This constant contains the project name used throughout the application
 * for branding and identification purposes.
 * 
 * @example
 * ```typescript
 * import { PROJECT_NAME } from '@shared/constants';
 * 
 * document.title = `${PROJECT_NAME} - Dashboard`;
 * ```
 */
export const PROJECT_NAME = 'LEXI'; 